var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-container"},[_c('span',{staticClass:"validator-status",class:_vm.status_class,attrs:{"title":_vm.status_detailed}},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }